import { useCurrentLocale } from '../contexts/CurrentLanguageContext'
import { getPossibleLocales } from '../model/locale'
import { useMemo } from 'react'

export function usePossibleLocales() {
	const locale = useCurrentLocale()
	return useMemo(() => getPossibleLocales(locale), [locale])
}
